<div class="legend-container">
    <div class="legend-title">Legend:</div>
    <div *ngIf="this.legendService.isLoading$ | async" class="legend-loader">
        Loading...
    </div>
    <div *ngIf="!(this.legendService.isLoading$ | async)" class="legend-items">
        <div *ngFor="let group of grouppedItems">
            <ul class="legend-list">
                <li
                    *ngFor="let series of group"
                    (click)="toggleLegend(series.splitId)"
                >
                    <span
                        class="color-box"
                        [style.background-color]="
                            series.state == 'active'
                                ? series.color
                                : series.color + '80'
                        "
                    ></span
                    ><span
                        [style.color]="
                            series.state == 'active' ? 'black' : '#D3D3D3'
                        "
                        >{{ series.splitId }}</span
                    >
                </li>
            </ul>
        </div>
    </div>
</div>
